<div class="wrapper w-100">
  <!-- Sidebar -->

  <nav id="sidebar" [ngClass]="status ? 'active' : ''">
      <div class="close-button" type="button" id="sidebarCollapse" (click)="status=!status">
        <span *ngIf="status"><i class="fas fa-angle-right"></i></span>

        <span *ngIf="!status"><i class="fas fa-angle-left"></i></span>
      </div>
      <div class="sidebar-header">
          <h3>{{'NavMenu.RealEstateToolkit'|translate}}</h3>
      </div>

      <ul class="list-unstyled components">

        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="newsroom">{{'Newsroom.SearchTitle'|translate}}</a>
        </li>

        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="proposition-13">{{'Prop13.SearchTitle'|translate}}</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="proposition-19">{{'Prop19.SearchTitle'|translate}}</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="property-search">{{'NavMenu.PropSearchTool'|translate}}</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="data-sales">{{'DataSales.SearchTitle'|translate}}</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="disaster-relief">{{'NavMenu.DisasterRelief'|translate}}</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="supplemental-tax-estimator">{{'NavMenu.SupplementalEstimator'|translate}}</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="change-of-mailing-address">{{'NavMenu.ChangeMailingAdd'|translate}}</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="new-construction">{{'NavMenu.NewConst'|translate}}</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="real-estate-fraud">{{'RealEstateFraud.SearchTitle'|translate}}</a>
        </li>
        <!--
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="factors-prop-value">{{'FactorsPropValue.SearchTitle'|translate}}</a>
        </li>
        -->
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="how-we-calculate-fmv">{{'CalculateFMV.SearchTitle'|translate}}</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="wills-and-trusts">{{'WillsandTrust.SearchTitle'|translate}}</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="new-homeowners">{{'NavMenu.NewHomeowners'|translate}}</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="apply-for-hox">{{'NavMenu.HomeExv2'|translate}}</a>
        </li>

        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="refinance">{{'Refinance.SearchTitle'|translate}}</a>
        </li>

        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="when-do-i-get-reassessed">{{'WhenReassessed.SearchTitle'|translate}}</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="death-of-a-property-owner">{{'NavMenu.DeathofOwner'|translate}}</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="events">{{'NavMenu.Events'|translate}}</a>
        </li>
        <li>
          <a [innerHTML]="'Newsletters'|translate" routerLinkActive="active-tab" (click)="status=!status" routerLink="Newsletters"></a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="enotification">{{'E-notification'|translate}}</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="AnnualReport">{{'NavMenu.AnnualReport'|translate}}</a>
        </li>



      </ul>

  </nav>
  <div id="content">

            <!-- <button type="button" id="sidebarCollapse" (click)="status=!status" class="btn btn-info">
                <i class="fas fa-align-left"></i>
                <span>Toggle Sidebar</span>
            </button> -->
            <router-outlet></router-outlet>
</div>


</div>
